interface ITextField {
  label: string;
  value: string;
  type: string;
  error: string;
  disabled: boolean;
}

export const ACCOUNT_SETTINGS_TEXT_FIELDS: ITextField[] = [
  {
    label: 'First Name',
    value: 'firstname',
    type: 'text',
    error: 'firstname',
    disabled: true,
  },
  {
    label: 'Last Name',
    value: 'lastname',
    type: 'text',
    error: '',
    disabled: true,
  },
  {
    label: 'Email',
    value: 'email',
    type: 'email',
    error: 'email',
    disabled: true,
  },
  {
    label: 'Phone Number',
    value: 'mobile',
    error: 'mobile',
    type: 'text',
    disabled: false,
  },
  /*
  {
    label: 'Address Line 1',
    value: 'addressLine1',
    type: 'text',
    error: 'address',
    disabled: false,
  },
  {
    label: 'Address Line 2',
    value: 'addressLine2',
    type: 'text',
    error: '',
    disabled: false,
  },
  {
    label: 'City',
    value: 'city',
    type: 'text',
    error: '',
    disabled: false,
  },
  {
    label: 'Province',
    value: 'province',
    error: '',
    type: 'text',
    disabled: false,
  },
  */
];

export const PASSWORD_FIELDS: ITextField[] = [
  {
    label: 'New Password',
    value: 'password',
    type: 'password',
    error: 'password',
    disabled: false,
  },
  {
    label: 'Confirm Password',
    value: 'confirmPassword',
    type: 'password',
    error: 'confirmPassword',
    disabled: false,
  },
];
